export const calculateStep3 = (state) => {
  return (Math.trunc(state.currentLifeInsurance * -1)) + Math.trunc(state.finalExpenses)
}

export const calculateStep4 = (state) => {
  return state.step >= 4 ? (Math.trunc(state.mortgage) + Math.trunc(state.personalBusinessDebt)) : 0
}

export const calculateStep5 = (state) => {
  return state.step >= 5 ? (Math.trunc(state.annualCostOfEducation) * Math.trunc(state.numOfChildren) * Math.trunc(state.yearsToProvide)) : 0
}

export const calculateStep6 = (state) => {
  return state.step >= 6 ? (Math.trunc(state.netAnnualIncome) * Math.trunc(state.yearsOfIncomeAfterDeath)) : 0
}

const calculateAll = (state) => {
  return calculateStep3(state) + calculateStep4(state) + calculateStep5(state) + calculateStep6(state)
}

export const calculateAge = (dateSelected) => {
  // if they clear their age we'll set it to zero, the old default
  if (!(typeof (dateSelected) === typeof Date)) {
    return 0
  }

  let today = new Date()
  let birthDate = dateSelected
  let age = today.getFullYear() - birthDate.getFullYear()
  let m = today.getMonth() - birthDate.getMonth()

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

export const transformState = (newValue, currentState) => {
  const newState = { ...currentState, ...newValue }
  if (newState.step === 2) {
    newState.yearsOfIncomeAfterDeath = Math.max(18 - newState.youngestChildAge, 0)
  }
  return { ...newState, estimate: calculateAll(newState) }
}
